import useTranslate from '@core/hooks/useTranslate';
import { ADMIN_SELLER_API_MENU } from '@root/core/constants/SellerApi/seller-api-menu';
import SellerApiImport from '@root/modules/SellerApi/Imports/pages/SellerApiImports';
import SellerApiOrder from '@root/modules/SellerApi/Orders/pages/SellerApiOrdersNormal';
import SellerApiOrderReturn from '@root/modules/SellerApi/Orders/pages/SellerApiOrdersReturn';
import SellerApiProducts from '@root/modules/SellerApi/Products/pages/SellerApiProducts';
import SellerApiQuotation from '@root/modules/SellerApi/Quotations/pages/SellerApiQuotation';

import SellerApiWarehouse from '@root/modules/SellerApi/Warehouse/pages/SellerApiWarehouse';

import { Layout, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;
interface Props {
  path?: string;
}

const SellerApiSideBar = ({ path = '' }: Props) => {
  const [t] = useTranslate();
  const [collapsed, setCollapsed] = useState(false);
  const [selected, setSeclected] = useState('');
  const [a, setA] = useState([] as any);
  const activeItem = (event: any) => {
    setSeclected(event.key);
  };
  const location = useLocation();

  useEffect(() => {
    let a = location;
    const b = a.pathname.replace('/admin/', '').split('/');
    setA(b);
  }, [location]);

  const colorParent = (item: {
    id: number;
    name?: string;
    label?: string;
    url: string;
    children?: { id: number; name: string; url: string }[];
  }) => {
    let isBold =
      !a[1] && item.url == '/admin/seller-api'
        ? 'bold'
        : a[1] == item.url.replace('/admin/seller-api/', '')
        ? 'bold'
        : !!a[1] &&
          a[1]
            .replace('/admin/seller-api/', '')
            .split('-')
            .includes(item.url.replace('/admin/seller-api/', ''))
        ? 'bold'
        : '500';
    return isBold;
  };

  const colorHasChild = (item: {
    id: number;
    name?: string;
    label?: string;
    url?: string;
    children: { id: number; name: string; url: string }[];
  }) => {
    let isbold = false;
    item.children.forEach((child) => {
      let bold =
        !!a[1] && !a[2] && a[1] == child.url.replace('/admin/seller-api/', '')
          ? true
          : !!a[2] &&
            a[2] == child.url.replace('/admin/seller-api/' + a[1] + '/', '')
          ? true
          : !!a[2] &&
            child.url.includes(a[1]) &&
            child.url
              .replace('/admin/seller-api/', '')
              .split('/')[0]
              .includes(a[1])
          ? true
          : false;
      if (bold) isbold = true;
    });
    return isbold ? 'bold' : '500';
  };

  const renderAdminOrStoreHeader = () => {
    return (
      <>
        <Layout className="navigation">
          <Sider collapsedWidth="48" width="230" className="side-bar__menu">
            <Menu
              mode="inline"
              style={{ height: '100%', borderRight: 0 }}
              selectedKeys={[path]}
            >
              {ADMIN_SELLER_API_MENU.map((item: any, index: number) => (
                <>
                  {item.children ? (
                    <Menu.SubMenu
                      title={item.label}
                      key={index + 200}
                      style={{ fontWeight: colorHasChild(item) }}
                    >
                      {item.children.map((child: any, idx: number) => (
                        <>
                          {child.children ? (
                            <Menu.SubMenu
                              title={child.label}
                              key={index + 400}
                              style={{ fontWeight: colorHasChild(child) }}
                            >
                              {child.children.map(
                                (childChild: any, childChildIdx: number) => (
                                  <Menu.Item
                                    key={idx + index * 10 + childChildIdx * 10}
                                  >
                                    <Link
                                      to={childChild.url}
                                      style={{
                                        fontWeight:
                                          childChild.url ===
                                            location.pathname ||
                                          (childChild.hiddenChildren &&
                                            childChild.hiddenChildren.find(
                                              (h: any) =>
                                                h.url === location.pathname ||
                                                h.url.test(location.pathname)
                                            ))
                                            ? 'bold'
                                            : '500'
                                      }}
                                    >
                                      {t(childChild.name)}
                                    </Link>
                                  </Menu.Item>
                                )
                              )}
                            </Menu.SubMenu>
                          ) : (
                            <Menu.Item key={idx + index * 10}>
                              <Link
                                to={child.url}
                                style={{
                                  fontWeight:
                                    !!a[1] &&
                                    !a[2] &&
                                    a[1] ==
                                      child.url.replace(
                                        '/admin/seller-api/',
                                        ''
                                      )
                                      ? 'bold'
                                      : (!!a[2] &&
                                          (a[2] ==
                                            child.url.replace(
                                              '/admin/seller-api/' + a[1] + '/',
                                              ''
                                            ) ||
                                            (!isNaN(a[2]) &&
                                              child.url.replace(
                                                '/admin/seller-api/' + a[1],
                                                ''
                                              ) == ''))) ||
                                        (child.hiddenChildren &&
                                          child.hiddenChildren
                                            .map((v: any) => v.url)
                                            .includes(location.pathname))
                                      ? 'bold'
                                      : '500'
                                }}
                              >
                                {t(child.name)}
                              </Link>
                            </Menu.Item>
                          )}
                        </>
                      ))}
                    </Menu.SubMenu>
                  ) : (
                    <Menu.Item
                      className={'menu-nav'}
                      title={item.label}
                      onClick={(event) => activeItem(event)}
                      key={index + 300}
                    >
                      <Link
                        key={item.id + 1000}
                        to={item.url}
                        style={{
                          color:
                            selected === `tmp_key-${index}` ? '#0077ff' : '',
                          fontWeight: colorParent(item)
                        }}
                      >
                        {t(item.name)}
                      </Link>
                    </Menu.Item>
                  )}
                </>
              ))}
            </Menu>
          </Sider>
          <Layout>
            <Content
              style={{
                minHeight: 280,
                minWidth: 1080,
                overflow: 'scroll'
              }}
            >
              <Switch>
                <Route exact={true} path="/admin/seller-api/warehouse">
                  <SellerApiWarehouse />
                </Route>
                <Route exact={true} path="/admin/seller-api/quotation">
                  <SellerApiQuotation />
                </Route>
                <Route exact={true} path="/admin/seller-api/import">
                  <SellerApiImport />
                </Route>
                <Route exact={true} path="/admin/seller-api/product">
                  <SellerApiProducts />
                </Route>
                <Route exact={true} path="/admin/seller-api/order/normal">
                  <SellerApiOrder />
                </Route>
                <Route exact={true} path="/admin/seller-api/order/return">
                  <SellerApiOrderReturn />
                </Route>

                <Route path="">
                  <Redirect to="/admin/seller-api/warehouse" />
                </Route>
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </>
    );
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(SellerApiSideBar);
